export class CacheManager {
    private static instance: CacheManager;
    private storage: Map<string, any>;

    private constructor() {
        this.storage = new Map<string, any>();
    }

    public static getInstance(): CacheManager {
        if (!CacheManager.instance) {
            CacheManager.instance = new CacheManager();
        }
        return CacheManager.instance;
    }

    /**
     * Saves an item to the cache.
     * @param key The unique key for the item.
     * @param data The data to save.
     */
    setItem(key: string, data: any): void {
        try {
            this.storage.set(key, data);
        } catch (error) {
            console.error('Error saving to cache', error);
        }
    }

    /**
     * Retrieves an item from the cache.
     * @param key The unique key for the item.
     * @returns The data if found, otherwise null.
     */
    getItem<T>(key: string): T | null {
        try {
            return (this.storage.get(key) as T) || null;
        } catch (error) {
            console.error('Error reading from cache', error);
            return null;
        }
    }

    /**
     * Removes a specific item from the cache.
     * @param key The unique key for the item.
     */
    removeItem(key: string): void {
        this.storage.delete(key);
    }

    /**
     * Invalidates all keys starting with the given prefix.
     * Use this when a resource is created, updated, or deleted to clear all related cache entries.
     * @param prefix The prefix of the keys to remove (e.g., "products-").
     */
    invalidate(prefix: string): void {
        const keysToRemove: string[] = [];
        for (const key of this.storage.keys()) {
            if (key.startsWith(prefix)) {
                keysToRemove.push(key);
            }
        }
        keysToRemove.forEach(key => this.storage.delete(key));
    }

    /**
     * Clears the entire cache.
     */
    clear(): void {
        this.storage.clear();
    }
}

export const cacheManager = CacheManager.getInstance();
